import InfoTip, {P} from '../../../components/info-tip/info-tip';

const ShiftInfo = function () {
  return (
    <InfoTip
      info={
        <section className={'w-[300px]'}>
          <h3>排班範例說明</h3>
          <P>Ｑ: 若要幫員工選擇 「班別A」，且班別A包含早班及晚班，系統該如何設定？</P>
          <P>
            A:
            <br />
            步驟1：先在系統設定早班及晚班的班次。
            <br />
            步驟2：創建班別A後，選擇早班及晚班。
            <br />
            步驟3：套用至員工身上。
          </P>
        </section>
      }
    />
  );
};

export default ShiftInfo;
